/**
 * 🎓 TICKET MTSKJ2 - API Service para progreso del alumno por curso
 * 
 * Wrapper para endpoints de tracking de completitud de actividades.
 */

import apiClient from './apiClient';

/**
 * Obtener progreso del usuario en un curso específico
 * GET /api/courses/:courseId/progress
 * 
 * @param {string} courseId - ID del curso (ej: "design-thinking")
 * @returns {Promise<Object>} { courseId, completedActivities, updatedAt }
 */
export const getCourseProgress = async (courseId) => {
  try {
    const response = await apiClient.get(`/courses/${courseId}/progress`);
    return response.data;
  } catch (error) {
    console.error('❌ [courseProgressApi] Error al obtener progreso:', error);
    throw error;
  }
};

/**
 * Marcar una actividad como completada
 * POST /api/courses/:courseId/progress/complete
 * 
 * @param {string} courseId - ID del curso
 * @param {string} activityId - ID de la actividad a completar
 * @returns {Promise<Object>} { courseId, completedActivities, updatedAt }
 */
export const markActivityComplete = async (courseId, activityId) => {
  try {
    const response = await apiClient.post(`/courses/${courseId}/progress/complete`, {
      activityId
    });
    return response.data;
  } catch (error) {
    console.error('❌ [courseProgressApi] Error al marcar actividad:', error);
    throw error;
  }
};

/**
 * Resetear progreso de un curso (QA/debugging)
 * POST /api/courses/:courseId/progress/reset
 * 
 * @param {string} courseId - ID del curso
 * @returns {Promise<Object>} { courseId, completedActivities, updatedAt }
 */
export const resetCourseProgress = async (courseId) => {
  try {
    const response = await apiClient.post(`/courses/${courseId}/progress/reset`);
    return response.data;
  } catch (error) {
    console.error('❌ [courseProgressApi] Error al resetear progreso:', error);
    throw error;
  }
};

/**
 * Obtener progreso de todos los cursos del usuario
 * GET /api/courses/progress/all
 * 
 * @returns {Promise<Object>} { progress: [{ courseId, completedActivities, updatedAt }] }
 */
export const getAllCoursesProgress = async () => {
  try {
    const response = await apiClient.get('/courses/progress/all');
    return response.data;
  } catch (error) {
    console.error('❌ [courseProgressApi] Error al obtener progreso de todos los cursos:', error);
    throw error;
  }
};
